/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from '../graph/defs.defs.js'

const $nsid = 'app.bsky.unspecced.getSuggestedStarterPacks'

export { $nsid }

/** Get a list of suggested starterpacks */
const main = l.query(
  $nsid,
  l.params({
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 25 }), 10),
    ),
  }),
  l.jsonPayload({
    starterPacks: l.array(
      l.ref<GraphDefs.StarterPackView>(
        (() => GraphDefs.starterPackView) as any,
      ),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
